import LogoutMutation from './LogoutMutation';

export default LogoutMutation;
